import { Component, OnInit, DestroyRef } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { StateService } from '@uirouter/core';
import { BreadcrumbComponent } from '@client/app/feature-modules/shared/components/breadcrumb/breadcrumb.component';
import { MenuItem } from 'primeng/api';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';
import { AdminLayoutService, BreadcrumbItem } from '@client/app/feature-modules/admin/services/admin-layout.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'mon-admin-layout',
    templateUrl: './admin-layout.component.html',
    imports: [
        UIRouterModule,
        BreadcrumbComponent,
        TranslocoModule,
    ],
    styleUrls: ['./admin-layout.component.css'],
})

export class AdminLayoutComponent implements OnInit {
    breadcrumbs: MenuItem[] = [];
    showBreadcrumbs = false;

    constructor (
        private translocoService: TranslocoService,
        private adminLayoutService: AdminLayoutService,
        private stateService: StateService,
        private destroyRef: DestroyRef,
    ) { }

    ngOnInit (): void {
        this.adminLayoutService.breadcrumbs$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(breadcrumbs => {
                this.breadcrumbs = this.convertToMenuItems(breadcrumbs);
                this.showBreadcrumbs = breadcrumbs.length > 0;
            });
    }

    private convertToMenuItems (breadcrumbs: BreadcrumbItem[]): MenuItem[] {
        const adminDashboard: MenuItem = {
            label: this.translocoService.translate('admin.dashboard.breadcrumbLabel'),
            command: (): void => {
                this.stateService.go('base.customer.admin.dashboard');
            },
        };

        const breadcrumbMenuItems = breadcrumbs.map(breadcrumb => ({
            label: this.translocoService.translate(breadcrumb.label),
            command: (): void => {
                this.stateService.go(breadcrumb.state);
            },
        }));

        return [adminDashboard, ...breadcrumbMenuItems];
    }
}
